import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
export default function extendDiscussionListState() {
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    var _tag$isQnA;
    if (!app.discussions.bestAnswer) return;

    // The choice is kept on the shared list state, so it must only apply to a list of a Q&A tag.
    const slug = this.params.tags;
    const tag = slug ? app.store.getBy('tags', 'slug', slug) : undefined;
    if (!(tag != null && (_tag$isQnA = tag.isQnA) != null && _tag$isQnA.call(tag))) return;
    const prepend = app.discussions.bestAnswer === '2' ? '-' : '';
    if (!params.filter) {
      params.filter = {};
    }
    params.filter["".concat(prepend, "solved-discussions")] = 'true';
  });
}
flarum.reg.add('fof-best-answer', 'forum/extenders/extendDiscussionListState', extendDiscussionListState);